import { List } from 'immutable';
import { composeInitialState } from '@opengov/compose-app';
import { EmptyListOf } from '@opengov/compose-app/immutable';
import { IEntity } from '@opengov/api-deprecated';

import { composeStateMachine } from '../module';
import { sessionActions } from '../session/actionsAndReducer';

import { Entity } from './records';

export const initialState = composeInitialState({
  entity: Entity(),
  entities: EmptyListOf(Entity),
  requestedEntity: null,
  searchText: '',
  isSelectPanelOpen: false
});

export const entityState = composeStateMachine(
  'entity',
  initialState,
  (compose) => ({
    fetchEntitySuccess: compose.action((state, entity: IEntity) => state.set('entity', Entity(entity))),

    fetchRequestedEntitySuccess: compose.action((state, entity: IEntity) =>
      state
        .set('requestedEntity', Entity(entity))
        // This next line is for backwards compatibility since our apps
        // currently expect 'entity' to represent `requestedEntity`
        .set('entity', Entity(entity))
    ),

    fetchEntitiesSuccess: compose.action((state, entities: IEntity[]) =>
      state.set('entities', List(entities.map(Entity)))
    ),

    searchEntities: compose.action((state, searchText: string) => state.set('searchText', searchText)),

    toggleEntitySelectPanel: compose.payloadlessAction((state) => state.update('isSelectPanelOpen', (value) => !value))
  }),
  (compose) => [
    compose.actionReducer(sessionActions.fetchSessionSuccess, (state, session) => {
      return state.set('entity', Entity(session.entity));
    })
  ]
);

export const {
  actions: entityActions,
  actionCreators: entityActionCreators,
  reducer: entityReducer,
  selector: entitySelector
} = entityState;
